import { all, put, takeEvery, call } from 'redux-saga/effects';
import actions from './actions';
import { getRequest } from '../../../../helpers/axiosClient';

export function* getDashboard(params) {
    try {
        let response = yield call(() => getRequest(params.url));
        yield put({
            type: actions.ADMIN_DASHBOARD_SUCCESS,
            payload: response?.data
        });
    } catch (error) {
        yield put({ type: actions.ADMIN_DASHBOARD_FAILURE, message: error?.response?.data });
        return error;
    }
}

export default function* adminDashboardSaga() {
    yield all([
        takeEvery(actions.ADMIN_DASHBOARD_START, getDashboard)
    ]);
}